import Box from '@mui/material/Box';
import { useTranslate } from 'react-admin';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { IconButton, ListItemSecondaryAction } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { getCleanName } from '@/utils/strings';
import CollapseMenu from '@/components/common/collapse-menu/collapse-menu';

interface Props {
    documents: {
        name: string;
        urlToDownload: string;
    }[];
}

const ShowNoteDocuments = ({ documents }: Props) => {
    const translate = useTranslate();

    const openFile = (url: string) => {
        window.open(url, '_blank');
    };

    return (
        <CollapseMenu defaultOpen={true} icon={<AttachFileIcon />} text={translate('app.objects.documents')}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 1,
                    px: 2,
                }}
            >
                <List
                    sx={{
                        width: '100%',
                        p: 0,
                    }}
                >
                    {documents.map(({ urlToDownload, name }) => (
                        <ListItem key={urlToDownload}>
                            <ListItemIcon
                                sx={{
                                    minWidth: 40,
                                }}
                            >
                                <PictureAsPdfIcon />
                            </ListItemIcon>

                            <ListItemText primary={getCleanName(name)} />

                            <ListItemSecondaryAction>
                                <IconButton edge='end' onClick={() => openFile(urlToDownload)}>
                                    <GetAppIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </CollapseMenu>
    );
};

export default ShowNoteDocuments;
